module.exports = __webpack_public_path__ + "img/flag-swedish.56db80ad.jpg";